import React, { use, useState } from 'react';
import { Button, Space, Table, TableColumnsType, Tag } from 'antd';
import { useRequest } from 'ahooks';
import {
  AiModelListVo,
  getModelList,
  ModelProviderVo,
  updateModelConfigProvider,
  updateModelStatus,
} from '@/api/model';
import { useUpdate } from '@/common/hook';
import EditProvider from './editModal';

const providerColumns: TableColumnsType<ModelProviderVo> = [
  { title: '模型供应商', dataIndex: 'providerZh', key: 'providerZh' },
  {
    title: '头像',
    dataIndex: 'logo',
    key: 'logo',
    render: text => <img src={text} alt="logo" style={{ height: 30 }} />,
  },
  { title: 'API Key', dataIndex: 'apiKey', key: 'apiKey' },
];

const modelColumns: TableColumnsType<AiModelListVo> = [
  { title: '模型名称', dataIndex: 'modelName', key: 'modelName' },
  { title: '类型', dataIndex: 'modelType', key: 'modelType' },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    render: (text: boolean) => <Tag color={text ? 'green' : 'red'}>{text ? '启用' : '禁用'}</Tag>,
  },
];

const Model = () => {
  const [editData, setEditData] = useState<ModelProviderVo>();
  const [visible, setVisible] = useState<boolean>(false);
  const [update, updateFn] = useUpdate();

  const { data: modelList, loading } = useRequest(getModelList, { refreshDeps: [update] });

  const changeModelStatus = (params: AiModelListVo) => {
    updateModelStatus({ id: params.id, status: !params.status }).then(updateFn);
  };
  const changeProviderStatus = (params: ModelProviderVo) => {
    updateModelConfigProvider({ id: params.id, status: !params.status }).then(updateFn);
  };

  const expandColumns = [
    ...modelColumns,
    {
      title: '操作',
      key: 'operation',
      render: (_: any, record: AiModelListVo) => (
        <Button type="link" size="small" style={{ padding: 0 }} onClick={() => changeModelStatus(record)}>
          {record.status ? '禁用' : '启用'}
        </Button>
      ),
    },
  ];

  const buildColumns = [
    ...providerColumns,
    {
      title: '操作',
      key: 'operation',
      render: (_: any, record: ModelProviderVo) => (
        <Space size={8}>
          <Button
            type="link"
            size="small"
            style={{ padding: 0 }}
            onClick={() => {
              setEditData(record);
              setVisible(true);
            }}
          >
            编辑
          </Button>
        </Space>
      ),
    },
  ];

  const expandedRowRender = (record: ModelProviderVo) => (
    <Table<AiModelListVo> columns={expandColumns} dataSource={record.aiModelList ?? []} pagination={false} />
  );

  return (
    <>
      <Table<ModelProviderVo>
        columns={buildColumns}
        expandable={{ expandedRowRender }}
        dataSource={modelList ?? []}
        loading={loading}
      />
      {visible && (
        <EditProvider
          data={editData}
          isEdit={!!editData}
          updateFn={updateFn}
          onCancel={() => {
            setVisible(false);
            setEditData(undefined);
          }}
        />
      )}
    </>
  );
};

export default Model;
